import {
  type DataTableFeatures,
  type DataTableFilterPanelGroup,
  DataTableFilterToggle,
  DataTableToolbar
} from 'design-system';

import type { ReactTable } from '@tanstack/react-table';
import type { CatalogItem } from '@/entities/catalog-item';

import DisplaySettingsButton from './DisplaySettings/DisplaySettingsButton';
import TableSearch from './TableSearch/TableSearch';

type CatalogToolbarProps = {
  filterOpen: boolean;
  groups: DataTableFilterPanelGroup<CatalogItem>[];
  setFilterOpen: (filterOpen: boolean) => void;
  table: ReactTable<DataTableFeatures, CatalogItem>;
  isForwardCurves: boolean;
  displaySettingsOpen: boolean;
  setDisplaySettingsOpen: (open: boolean) => void;
};

const CatalogToolbar = ({
  filterOpen,
  groups,
  setFilterOpen,
  table,
  isForwardCurves,
  displaySettingsOpen,
  setDisplaySettingsOpen
}: CatalogToolbarProps) => {
  return (
    <DataTableToolbar.Root table={table}>
      <DataTableToolbar.Start>
        <DataTableFilterToggle
          groups={groups}
          open={filterOpen}
          table={table}
          onOpenChange={setFilterOpen}
        />
        <DisplaySettingsButton
          open={displaySettingsOpen}
          table={table}
          onToggle={() => setDisplaySettingsOpen(!displaySettingsOpen)}
        />
      </DataTableToolbar.Start>
      <DataTableToolbar.End>
        <TableSearch tabId={`catalog-search-${isForwardCurves ? 'forward-curves' : 'spot'}`} />
      </DataTableToolbar.End>
    </DataTableToolbar.Root>
  );
};

export default CatalogToolbar;
